import React from "react";
import { Box, Container, Typography } from "@mui/material";

const SirketKurulusu = () => {
    return (
        <Container maxWidth="md" sx={{ py: 5 }}>
            <Box textAlign="center" mb={4}>
                <Typography variant="h4" fontWeight="bold" gutterBottom>
                    Şirket Kuruluşunda Güvenilir Çözüm Ortağınız
                </Typography>
                <Typography variant="subtitle1" color="textSecondary">
                    Biz; iş dünyasına adım atmak isteyen girişimcilerin yanında duruyor ve şirket kuruluş süreçlerinde güvenilir çözüm ortağı olmayı taahhüt ediyoruz.
                </Typography>
            </Box>

            <Typography variant="body2" color="textPrimary" paragraph>
                Girişimcilerin iş dünyasına adım atmaları heyecan verici bir süreçtir. Ancak, bir şirketin sağlıklı bir temel üzerine inşa edilmesi, başarılı bir işletmeyi sürdürebilmek için kritik bir öneme sahiptir. Bu noktada, şirket kuruluş hizmetleri devreye girer ve işletmelerin yasal ve finansal zeminde güvenle olmalarını sağlar.
            </Typography>

            <Typography variant="h6" fontWeight="bold" gutterBottom>
                Şirket Kuruluş Adımları Şunlardır:
            </Typography>

            <Typography variant="h8" fontWeight="bold">1. Şirket Kuruluşu ve Tescili</Typography>
            <Typography variant="body2" color="textPrimary" paragraph>
                İlk adım, doğru şirket yapısını belirlemek ve bu yapıyı yasal olarak kurmaktır. Mali müşavirler, girişimcilere en uygun şirket türünü seçmeleri konusunda rehberlik ederler. Limited şirket (Ltd.), Anonim şirket (A.Ş.), veya Şahıs şirketi gibi seçenekler arasında doğru tercihi yapmak, şirketin gelecekteki başarısını etkileyebilir.
            </Typography>
            <Typography variant="body2" color="textPrimary" paragraph>
                Tescil süreci, ticaret sicili kaydından vergi numarası alınmasına kadar çeşitli aşamaları içerir. Mali müşavirler, bu süreci yöneterek müşterilerinin hukuki olarak güvence altına alınmalarını sağlarlar.
            </Typography>

            <Typography variant="h8" fontWeight="bold">2. Vergi Planlaması ve Danışmanlık</Typography>
            <Typography variant="body2" color="textPrimary" paragraph>
                Vergi yükümlülükleri, işletme sahipleri için karmaşık bir konu olabilir. Mali müşavirler, vergi planlaması yaparak müşterilerinin vergi avantajlarından en iyi şekilde faydalanmalarına yardımcı olurlar. Aynı zamanda vergi beyannamelerinin düzenlenmesi ve sürekli danışmanlığı ile işletmenin mali sağlığını korumak da görevleri arasındadır.
            </Typography>

            <Typography variant="h8" fontWeight="bold">3. Muhasebe ve Finansal Raporlama</Typography>
            <Typography variant="body2" color="textPrimary" paragraph>
                Muhasebe, işletmenin finansal sağlığını anlamak için kilit bir unsurdur. Mali müşavirler, düzenli muhasebe kayıtları tutarak şirketin gelir-gider dengesini yönetirler. Ayrıca, finansal raporlar hazırlayarak işletme sahiplerine net bir mali tablo sunarlar. Bu raporlar, işletmenin performansını değerlendirmek ve geleceğe dair stratejik kararlar almak için önemlidir.
            </Typography>

            <Typography variant="h8" fontWeight="bold">4. İş Planlama ve Strateji Geliştirme</Typography>
            <Typography variant="body2" color="textPrimary" paragraph>
                Mali müşavirler, müşterilerinin iş hedeflerine ulaşmalarına yardımcı olacak stratejiler geliştirirler. İş planları oluşturarak finansal hedeflere ulaşmak için adımlar atarlar. Bu süreçte, sektörel analizler ve rekabetçi stratejiler de belirlenerek işletmenin rekabet avantajını artırmak hedeflenir.
            </Typography>

            <Typography variant="h6" fontWeight="bold" gutterBottom>
                Şirket Kuruluş Hizmetlerimiz:
            </Typography>

            <Typography variant="body2" color="textPrimary" paragraph>
                <strong>1. Özel Danışmanlık Hizmetleri:</strong>İşinizi en iyi şekilde anlamak ve ihtiyaçlarınıza özel çözümler sunmak için uzman danışmanlarımızla bir araya geliyoruz. Şirketinizin yapısını belirlemek ve yasal gereksinimlere uygun bir şekilde kurulmasını sağlamak adına size özel stratejiler oluşturuyoruz.
            </Typography>

            <Typography variant="body2" color="textPrimary" paragraph>
                <strong>2. Hızlı ve Etkin Tescil Süreci:</strong>Şirket kuruluş sürecini hızlandırmak ve müşterilerimizi bürokratik karmaşadan korumak adına etkin tescil hizmetleri sunuyoruz. Ticaret sicili kayıtlarını düzenleyerek ve vergi numaralarını temin ederek şirketinizi faaliyete geçirmenize yardımcı oluyoruz.
            </Typography>

            <Typography variant="body2" color="textPrimary" paragraph>
                <strong>3. Vergi Planlaması ve Danışmanlık:</strong>Mali başarı için vergi planlaması önemlidir. Deneyimli vergi uzmanlarımız, müşterilerimizin vergi yükümlülüklerini optimize etmelerine yardımcı olmak ve vergi avantajlarından maksimum düzeyde faydalanmalarını sağlamak için çalışıyor.
            </Typography>

            <Typography variant="body2" color="textPrimary" paragraph>
                <strong>4. Muhasebe ve Finansal Yönetim:</strong>Şirketinizin finansal sağlığını kontrol altında tutmak için muhasebe ve finansal yönetim hizmetleri sunuyoruz. Düzenli raporlamalar ve bütçe analizleri ile işletmenizin mali durumunu anlamanıza yardımcı oluyoruz.
            </Typography>

            <Typography variant="body1" color="textPrimary" paragraph>
                Amacımız, müşterilerimize sadece bir muhasebe bürosu değil, işlerini güvenle büyütebilecekleri bir iş ortağı olmak. Şirket kuruluş süreçlerinizi bizimle birlikte yönetin ve iş dünyasındaki başarı yolculuğunuza ilk adımı atın.
            </Typography>
        </Container>
    );
};

export default SirketKurulusu;